import { createFileRoute, redirect } from '@tanstack/react-router';

import { sessionQueries } from '@/api';
import { NotificationsPage } from '@/features/notifications/notifications-page';

export const Route = createFileRoute('/notifications')({
	beforeLoad: async ({ context }) => {
		const session = await context.queryClient.ensureQueryData(sessionQueries.current());
		if (!session) throw redirect({ to: '/login', search: { redirect: '/notifications' } });
	},
	component: NotificationsPage,
	staticData: { workspace: true },
});
